import styled from 'styled-components'

import { fontType, toRem, transition } from '../../styles/functions'

interface IInputLabeledWrapper {
	$hasError: boolean
}

export const InputLabeledWrapper = styled.div<IInputLabeledWrapper>`
	display: flex;
	flex-direction: column;
	width: 100%;
	text-align: left;

	label {
		margin-bottom: 10px;
		color: ${({ theme }) => theme.colors.neutralGrey};
		font-size: ${toRem(14)};
		cursor: pointer;
		${fontType(0)}
	}

	input {
		height: 56px;
		width: 100%;
		padding: 0 20px;
		border: solid 1px
			${({ theme, $hasError }) =>
				$hasError ? theme.colors.red : theme.colors.lightGrey2};
		border-radius: 12px;
		background: ${({ theme }) => theme.colors.white};
		color: ${({ theme }) => theme.colors.darkGrey};
		font-size: ${toRem(14)};
		${fontType(0)}
		${transition()}

		/* evita o realce amarelo do autofill sem apagar o anel de foco */
		&:-webkit-autofill,
		&:-webkit-autofill:hover,
		&:-webkit-autofill:focus {
			-webkit-text-fill-color: ${({ theme }) => theme.colors.darkGrey};
			transition: background-color 9999s ease-in-out 0s;
		}

		&::placeholder {
			color: ${({ theme }) => theme.colors.secondaryDarkGrey};
		}

		&:focus {
			outline: none;
			border-color: ${({ theme, $hasError }) =>
				$hasError ? theme.colors.red : theme.colors.blue};
			box-shadow: 0 0 0 3px
				${({ theme, $hasError }) =>
					$hasError ? `${theme.colors.red}1F` : `${theme.colors.blue}1F`};
		}

		&:disabled {
			background: ${({ theme }) => theme.colors.lightWhite};
			cursor: not-allowed;
		}
	}

	.error {
		margin-top: 6px;
		color: ${({ theme }) => theme.colors.red};
		font-size: ${toRem(12)};
		${fontType(0)}
	}
`
